import './MainScreen.scss';
import { useNavigate } from 'react-router-dom';
import Button from '../Button';

const MainScreen = ({
  title,
  text,
  mainButtonText = '',
  onMainClick,
  secondButtonText = '',
  onSecondClick,
  background,
  afterTags = [],
  beforeTags = [],
}) => {
  const navigate = useNavigate();

  return (
    <div className='mainScreen'>
      <span className='mainScreenBackground'>
        <img src={background} />
      </span>
      {!!beforeTags && !!beforeTags.length && (
        <div className='mainScreenTags'>
          {beforeTags.map(item => (
            <span className='mainScreenTag'>{item}</span>
          ))}
        </div>
      )}
      <h1 className='mainScreenTitle'>{title}</h1>
      <span className='mainScreenText'>{text}</span>
      {!!afterTags && !!afterTags.length && (
        <div className='mainScreenTags'>
          {afterTags.map(item => (
            <span className='mainScreenTag'>{item}</span>
          ))}
        </div>
      )}
      {mainButtonText && (
        <div className='mainScreenButtons'>
          <Button type='primary' text={mainButtonText} onClick={onMainClick} />
          {secondButtonText && <Button text={secondButtonText} onClick={onSecondClick} />}
        </div>
      )}
    </div>
  );
};

export default MainScreen;
